module.exports = __webpack_public_path__ + "static/img/vip_group_title.7b09baa2.png";